import { LoadedFile } from '../services/FileService';
import { simplifyFilenames } from './filenameSimplifier';

// Utility function to extract filename from URL
const extractFileNameFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const parts = pathname.split('/').filter(p => p);
    
    if (parts.length > 0) {
      let fileName = decodeURIComponent(parts[parts.length - 1]);
      // Remove query parameters if any
      const queryIndex = fileName.indexOf('?');
      if (queryIndex > 0) {
        fileName = fileName.substring(0, queryIndex);
      }
      
      if (fileName && fileName.length < 200 && fileName !== url) {
        return fileName;
      }
    }
  } catch {
    // URL parsing failed
  }
  
  // Fallback: try to extract from the URL string directly
  try {
    const lastSlash = url.lastIndexOf('/');
    if (lastSlash >= 0 && lastSlash < url.length - 1) {
      const potentialName = url.substring(lastSlash + 1);
      const queryIndex = potentialName.indexOf('?');
      let fileName = queryIndex > 0 ? potentialName.substring(0, queryIndex) : potentialName;
      fileName = decodeURIComponent(fileName);
      
      if (fileName && fileName.length < 200 && fileName !== url) {
        return fileName;
      }
    }
  } catch {
    // Decoding failed
  }
  
  return 'audio-file';
};

// Helper function to simplify filenames for loaded files that have URLs (direct links)
export const simplifyLoadedFileFilenames = (loadedFiles: LoadedFile[]): LoadedFile[] => {
  // Filter to only direct link files (have URLs)
  const directLinkFiles = loadedFiles.filter(f => f.originalUrl || f.shareableUrl);
  
  if (directLinkFiles.length < 2) {
    // Not enough files to simplify
    return loadedFiles;
  }
  
  // Extract original filenames from URLs
  const directLinkFilenames = directLinkFiles.map(f => {
    const url = f.originalUrl || f.shareableUrl || '';
    return extractFileNameFromUrl(url);
  });
  
  console.log('[Filename Simplification] Simplifying', directLinkFilenames.length, 'direct link files');
  console.log('[Filename Simplification] Original filenames:', directLinkFilenames);
  
  // Simplify all direct link filenames together
  const simplifiedFilenames = simplifyFilenames(directLinkFilenames);
  
  console.log('[Filename Simplification] Simplified filenames:', simplifiedFilenames);
  
  // Create a map of URL to simplified filename for lookup
  const urlToSimplifiedMap = new Map<string, string>();
  directLinkFiles.forEach((f, index) => {
    const url = f.originalUrl || f.shareableUrl || '';
    urlToSimplifiedMap.set(url, simplifiedFilenames[index]);
    console.log('[Filename Simplification] Mapping URL to simplified name:', url.substring(0, 50) + '...', '->', simplifiedFilenames[index]);
  });
  
  // Update all loaded files with simplified names
  return loadedFiles.map(f => {
    if (f.originalUrl || f.shareableUrl) {
      const url = f.originalUrl || f.shareableUrl || '';
      const simplifiedName = urlToSimplifiedMap.get(url);
      if (simplifiedName && simplifiedName !== f.file.name) {
        console.log('[Filename Simplification] Updating file from', f.file.name, 'to', simplifiedName);
        // Create new File object with simplified name
        const newFile = new File([f.file], simplifiedName, { type: f.file.type });
        return { ...f, file: newFile };
      }
    }
    return f;
  });
};
















